/**
 * 统一 API 基础地址（与 DSM 前端一致的代理模式）
 * - 开发环境：空字符串，请求相对路径 /api/...，由 devServer.proxy 转发到 127.0.0.1:8000
 * - 生产环境：由 VUE_APP_API_BASE_URL 指定（如 Nginx 反代则可为空）
 */
const isDev = process.env.NODE_ENV === 'development';
const apiBaseUrl = isDev
  ? ''
  : (process.env.VUE_APP_API_BASE_URL && process.env.VUE_APP_API_BASE_URL.trim()) || '';

export default apiBaseUrl;
